import { DeleteButton, SaveButton, Toolbar } from "react-admin";

export const FormEditChildToolbar = ({resource, deletable = false}) => (
    <Toolbar sx={{ justifyContent: "space-between" }}>
        <SaveButton resource={resource} mutationMode="pessimistic" />
        {deletable == true && (
        <DeleteButton resource={resource} mutationMode="pessimistic" />
        )}
    </Toolbar>
);
